import FirstLoginCategory from "./components/pages/FirstLoginCategory";
import Home from "./components/pages/Home";
import Login from "./components/pages/Login";
import SignUp from "./components/pages/SignUp";
import SignUpSuccess from "./components/pages/SignUpSuccess";


const routes = [
    {
        path: '/sign-up',
        exact: true,
        element: <SignUp />
    },
    {
        path: '/sign-up-success',
        exact: true,
        element: <SignUpSuccess />
    },
    {
        path: '/login',
        exact: true,
        element: <Login />
    },
    {
        path: '/choose-category',
        exact: true,
        element: <FirstLoginCategory />
    },
    {
        path: '/',
        exact: true,
        element: <Home />
    },

    {
        path: '*',
        exact: false,
        element: <div className='text-white'>404 page not found</div>
    },
]
export default routes;